import { apiClient, fastApiClient } from "../App";

// Campaign Timeline (extra me search jaisi query keys aati hain)
export const getCampaignTimeline = (id, extra = {}) => {
  const params = new URLSearchParams();

  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });

  const query = params.toString() ? `?${params.toString()}` : "";

  return fastApiClient.get(`/campaigns/${id}/timeline${query}`);
};

// Voice Report
export const getVoiceReport = (id) => {
  return fastApiClient.get(`/campaigns/${id}/voice-report`);
};

// Campaign List
export const getCampaignList = () => {
  return fastApiClient.get("/campaigns");
};

// Execute Campaign
export const executeCampaign = (id) => {
  return fastApiClient.post(`/campaigns/${id}/execute`);
};

// Pause Campaign
export const pauseCampaign = (id) => {
  return fastApiClient.post(`/campaigns/${id}/pause`);
};

// Resume Campaign
export const resumeCampaign = (id) => {
  return fastApiClient.post(`/campaigns/${id}/resume`);
};

// Delete Campaign
export const deleteCampaign = (id) => {
  return fastApiClient.delete(`/campaigns/${id}`);
};

// Download PDF
export const downloadCampaignPdf = (id) => {
  return fastApiClient.get(`/campaigns/${id}/report.pdf`, {
    responseType: "blob",
  });
};